import styles from "./ChatDownIcon.module.scss"

import React, { RefObject, useEffect, useState } from "react"
import { RiArrowDownLine } from "react-icons/ri"

import { useChatInfo, useSetChatInfo } from "@shared/contexts"

interface Props {
  messagesRef: RefObject<HTMLDivElement>
}

const MARGIN_ITEM = 27 * 3

export default function ChatDownIcon({ messagesRef }: Props) {
  const { isChatLock } = useChatInfo()
  const setChatInfo = useSetChatInfo()

  const [isScrollDown, setIsScrollDown] = useState<boolean>(false)

  useEffect(() => {
    let animationFrameId: number
    let currentEl = messagesRef.current

    const scrollDetect = () => {
      const el = messagesRef.current
      if (!el) return

      const messageBoxHeight = el.clientHeight || 0
      const currentNum = el.scrollTop || 0
      const height = el.scrollHeight || 0

      setIsScrollDown(currentNum + messageBoxHeight >= height - MARGIN_ITEM)
    }

    const checkRefChange = () => {
      if (messagesRef.current !== currentEl) {
        if (currentEl) {
          currentEl.removeEventListener("scroll", scrollDetect)
        }
        currentEl = messagesRef.current
        if (currentEl) {
          currentEl.addEventListener("scroll", scrollDetect)
          scrollDetect()
        }
      }
      animationFrameId = requestAnimationFrame(checkRefChange)
    }

    if (currentEl) {
      currentEl.addEventListener("scroll", scrollDetect)
      scrollDetect()
    }

    checkRefChange()

    const handleSync = (e: any) => {
      const { scrollTop, scrollHeight, clientHeight } = e.detail
      setIsScrollDown(scrollTop + clientHeight >= scrollHeight - MARGIN_ITEM)
    }
    window.addEventListener("chat-scroll-sync", handleSync)

    return () => {
      if (currentEl) {
        currentEl.removeEventListener("scroll", scrollDetect)
      }
      window.removeEventListener("chat-scroll-sync", handleSync)
      cancelAnimationFrame(animationFrameId)
    }
  }, [messagesRef])

  useEffect(() => {
    setChatInfo({
      type: "CHANGE_CHAT_LOCK",
      isChatLock: !isScrollDown,
    })
  }, [isScrollDown, setChatInfo])

  if (!isChatLock) {
    return null
  }

  return (
    <div title="끝으로 가기 (줄 잠금 해제)">
      <RiArrowDownLine
        className={styles.unChatLock}
        size={20}
        color={"#fff"}
        style={{
          backgroundColor: "#da7575",
          borderRadius: "50px",
          border: "1px",
          marginBottom: "14px",
        }}
        onClick={() => {
          setChatInfo({
            type: "CHANGE_CHAT_LOCK",
            isChatLock: false,
          })
        }}
      />
    </div>
  )
}
